import { render, staticRenderFns } from "./UploadRequirementExample.vue?vue&type=template&id=ffdd9e3c&scoped=true&"
import script from "./UploadRequirementExample.vue?vue&type=script&lang=js&"
export * from "./UploadRequirementExample.vue?vue&type=script&lang=js&"
import style0 from "./UploadRequirementExample.vue?vue&type=style&index=0&id=ffdd9e3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdd9e3c",
  null
  
)

export default component.exports